export const BankIconNew = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
    <path
      d="M30.925 5.37507L53.425 14.375C54.3 14.725 55 15.775 55 16.7V25C55 26.375 53.875 27.5 52.5 27.5H7.5C6.125 27.5 5 26.375 5 25V16.7C5 15.775 5.70001 14.725 6.57501 14.375L29.075 5.37507C29.575 5.17507 30.425 5.17507 30.925 5.37507Z"
      stroke={strokeColor}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55 55H5V47.5C5 46.125 6.125 45 7.5 45H52.5C53.875 45 55 46.125 55 47.5V55Z"
      stroke={strokeColor}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 45V27.5"
      stroke={strokeColor}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50 45V27.5"
      stroke={strokeColor}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 55H57.5"
      stroke={strokeColor}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 21.25C32.0711 21.25 33.75 19.5711 33.75 17.5C33.75 15.4289 32.0711 13.75 30 13.75C27.9289 13.75 26.25 15.4289 26.25 17.5C26.25 19.5711 27.9289 21.25 30 21.25Z"
      stroke={strokeColor}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
